<section class="message-list" aria-label="Conversation messages">
  <ng-container *ngFor="let message of messages; trackBy: trackByMessageId">
    <time
      *ngIf="dayStartMessageIds[message.id]"
      class="message-list__day-separator"
      [attr.datetime]="message.createdAt"
      >{{ message.createdAt | messageDay }}</time
    >
    <talk-to-your-data-message-item [message]="message"></talk-to-your-data-message-item>
  </ng-container>
  <div #bottomAnchor></div>
</section>
